function syncFacetSortSelectWidth(select) {
  if (!select || !select.matches?.('select.facet-filters__sort')) return;
  const option = select.options[select.selectedIndex];
  const text = (option?.text || '').trim();
  const span = document.createElement('span');
  span.setAttribute('aria-hidden', 'true');
  span.style.cssText =
    'position:absolute;left:-9999px;top:0;white-space:nowrap;pointer-events:none;visibility:hidden;';
  const cs = window.getComputedStyle(select);
  span.style.fontSize = cs.fontSize;
  span.style.fontFamily = cs.fontFamily;
  span.style.fontWeight = cs.fontWeight;
  span.style.fontStyle = cs.fontStyle;
  span.style.lineHeight = cs.lineHeight;
  span.style.letterSpacing = cs.letterSpacing;
  span.textContent = text;
  document.body.appendChild(span);
  const textWidth = span.offsetWidth;
  document.body.removeChild(span);
  const pl = parseFloat(cs.paddingLeft) || 0;
  const pr = parseFloat(cs.paddingRight) || 0;
  const bl = parseFloat(cs.borderLeftWidth) || 0;
  const br = parseFloat(cs.borderRightWidth) || 0;
  const px = Math.ceil(textWidth + pl + pr + bl + br + 1);
  select.style.width = `${px}px`;
  const toolbarForm = select.closest('#FacetSortToolbarForm');
  if (toolbarForm) toolbarForm.setAttribute('data-facet-sort-width', 'ready');
}

function syncAllFacetSortSelectWidths() {
  document.querySelectorAll('select.facet-filters__sort').forEach((el) => syncFacetSortSelectWidth(el));
}

function getMobileCollectionPathnameWithTagToggles() {
  const form = document.getElementById('FacetFiltersFormMobile');
  if (!form) return null;
  const toggles = form.querySelectorAll('.filter-toggle[data-tag]');
  if (!toggles.length) return null;

  const m = window.location.pathname.match(/^\/collections\/([^/]+)(?:\/(.*))?$/);
  if (!m) return null;

  const handle = m[1];
  const existingTags = (m[2] || '').split('+').filter(Boolean);
  const controlled = new Map();
  toggles.forEach((el) => {
    if (el.dataset.tag) controlled.set(el.dataset.tag, el.checked);
  });
  const nextTags = existingTags.filter((tag) => !controlled.has(tag));
  toggles.forEach((el) => {
    const tg = el.dataset.tag;
    if (!tg || !el.checked) return;
    nextTags.push(tg);
  });
  return nextTags.length
    ? `/collections/${handle}/${nextTags.join('+')}`
    : `/collections/${handle}`;
}

function syncMobileReadyToShipDuplicateControls(form) {
  const toggle = form.querySelector('.filter-toggle[name="filter.v.m.custom.ready_to_ship"]');
  const avail = form.querySelector('.availability-checkbox[name="filter.v.m.custom.ready_to_ship"]');
  if (toggle && avail) {
    avail.checked = toggle.checked;
  }
}

function removeOneFilterParamValueFromSearch(search, paramName, valueToRemove) {
  const qs = search.startsWith('?') ? search.slice(1) : search;
  if (!qs) return '';
  const sp = new URLSearchParams(qs);
  const out = new URLSearchParams();
  let removed = false;
  for (const [key, val] of sp.entries()) {
    if (key !== paramName) {
      out.append(key, val);
      continue;
    }
    if (!removed && val === valueToRemove) {
      removed = true;
      continue;
    }
    out.append(key, val);
  }
  return out.toString();
}

function escapeHtmlText(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function removeOneTagFromPathSegment(segment, tagHandleToRemove) {
  const parts = segment.split('+').filter(Boolean);
  const next = [];
  let removed = false;
  for (const p of parts) {
    if (!removed && p === tagHandleToRemove) {
      removed = true;
      continue;
    }
    next.push(p);
  }
  return next.join('+');
}

const MATERIAL_FILTER_PARAM = 'filter.v.m.custom.material';

const DIMENSION_RANGE_INPUT_DEBOUNCE_MS = 280;

const dimensionRangeInputFlushCallbacks = [];

function flushPendingDimensionRangeInputUpdates() {
  dimensionRangeInputFlushCallbacks.forEach((fn) => {
    fn();
  });
}

function mergeMaterialParamsFromUrlAndForm(merged, form) {
  const urlValues = new URLSearchParams(window.location.search).getAll(MATERIAL_FILTER_PARAM);
  merged.delete(MATERIAL_FILTER_PARAM);
  const inputs = [...form.querySelectorAll(`[name="${MATERIAL_FILTER_PARAM}"]`)];
  if (inputs.length === 0) {
    urlValues.forEach((v) => merged.append(MATERIAL_FILTER_PARAM, v));
    return;
  }
  const inputsByValue = new Map(inputs.map((el) => [el.value, el]));
  const used = new Set();
  for (const v of urlValues) {
    const input = inputsByValue.get(v);
    if (!input) {
      merged.append(MATERIAL_FILTER_PARAM, v);
      used.add(v);
      continue;
    }
    if (input.checked) {
      merged.append(MATERIAL_FILTER_PARAM, v);
      used.add(v);
    }
  }
  for (const input of inputs) {
    if (input.checked && !used.has(input.value)) {
      merged.append(MATERIAL_FILTER_PARAM, input.value);
    }
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this._facetSubmitDelayTimer = null;
    this.debouncedOnSubmit = (event) => {
      clearTimeout(this._facetSubmitDelayTimer);
      this._facetSubmitDelayTimer = setTimeout(() => {
        this._facetSubmitDelayTimer = null;
        this.onSubmitHandler(event);
      }, 500);
    };

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        const el = event.target;
        const isDimensionRangeInput =
          el.matches?.('[data-facet-input-type="dimension-range"]') ||
          el.classList?.contains('facets-range-dimension-input');
        if (isDimensionRangeInput) return;

        const isFilterToggle =
          el.matches?.('[data-facet-input-type="filter-toggle"]') || el.classList?.contains('filter-toggle');
        if (isFilterToggle) {
          if (event.target.name === 'filter.v.m.custom.ready_to_ship') {
            document
              .querySelectorAll(
                '[data-facet-input-type="availability"][name="filter.v.m.custom.ready_to_ship"], .availability-checkbox[name="filter.v.m.custom.ready_to_ship"]'
              )
              .forEach((cb) => {
                cb.checked = event.target.checked;
              });
          }
          return;
        }

        const isReadyToShipAvailability =
          event.target.name === 'filter.v.m.custom.ready_to_ship' &&
          (el.matches?.('[data-facet-input-type="availability"]') || el.classList?.contains('availability-checkbox'));
        if (isReadyToShipAvailability) {
          document
            .querySelectorAll(
              '[data-facet-input-type="filter-toggle"][name="filter.v.m.custom.ready_to_ship"], .filter-toggle[name="filter.v.m.custom.ready_to_ship"]'
            )
            .forEach((toggle) => {
              toggle.checked = event.target.checked;
            });
        }
        const t = event.target;
        if (t.matches?.('input[type="checkbox"], input[type="radio"], select')) {
          if (!event.isTrusted) {
            this.debouncedOnSubmit(event);
            return;
          }
          clearTimeout(this._facetSubmitDelayTimer);
          this._facetSubmitDelayTimer = null;
          this.onSubmitHandler(event);
          return;
        }
        this.debouncedOnSubmit(event);
      });

      if (facetForm.id === 'FacetFiltersFormMobile') {
        facetForm.addEventListener('change', (ev) => {
          const t = ev.target;
          if (t.matches?.('.filter-toggle[name="filter.v.m.custom.ready_to_ship"]')) {
            const avail = facetForm.querySelector('.availability-checkbox[name="filter.v.m.custom.ready_to_ship"]');
            if (avail) avail.checked = t.checked;
            return;
          }
          if (t.matches?.('.availability-checkbox[name="filter.v.m.custom.ready_to_ship"]')) {
            facetForm.querySelectorAll('.filter-toggle[name="filter.v.m.custom.ready_to_ship"]').forEach((el) => {
              el.checked = t.checked;
            });
          }
        });

        const applyBtn = facetForm.querySelector('[data-mobile-facets-apply]');
        if (applyBtn) {
          applyBtn.addEventListener('click', (e) => {
            e.preventDefault();
            flushPendingDimensionRangeInputUpdates();
            syncMobileReadyToShipDuplicateControls(facetForm);
            const syntheticEvent = {
              preventDefault: () => {},
              target: facetForm,
              srcElement: applyBtn,
              currentTarget: applyBtn,
            };
            const tagPathname = getMobileCollectionPathnameWithTagToggles();
            if (tagPathname !== null) {
              document.querySelectorAll('.no-js-list').forEach((el) => el.remove());
              const searchParams = FacetFiltersForm.getMergedSearchParamsForMobileApply(this, syntheticEvent);
              const hash = window.location.hash || '';
              const targetUrl = `${window.location.origin}${tagPathname}${searchParams ? `?${searchParams}` : ''}${hash}`;
              FacetFiltersForm.renderPageFromUrl(targetUrl, syntheticEvent);
            } else {
              this.onSubmitHandler(syntheticEvent);
            }
            facetForm.closest('.mobile-facets__wrapper')?.querySelector('summary')?.click();
          });
        }
      }
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = () => {
      const next = window.location.pathname + window.location.search;
      if (next === FacetFiltersForm.locationPrev) return;
      FacetFiltersForm.renderPageFromUrl(window.location.href, null, true);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static setMobileApplyBusy(busy) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    const btn = document.querySelector('#FacetFiltersFormMobile [data-mobile-facets-apply]');
    if (!btn) return;
    btn.toggleAttribute('disabled', busy);
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  static findProductGridUl(container) {
    const pg = document.getElementById('product-grid');
    if (pg && pg.tagName === 'UL') return pg;
    if (pg && pg.tagName === 'DIV') {
      const inner = pg.querySelector('ul.grid.product-grid, ul.product-grid');
      if (inner) return inner;
    }
    return container.querySelector('ul.grid.product-grid');
  }

  static ensureProductGridSkeleton() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || container.querySelector('[data-product-grid-skeleton]')) return;
    const collection = container.querySelector('.collection');
    const grid = FacetFiltersForm.findProductGridUl(container);
    if (!collection || !grid) return;
    const itemCount = grid.querySelectorAll('.grid__item').length;
    if (itemCount === 0) return;
    const skeleton = document.createElement('div');
    skeleton.dataset.productGridSkeleton = '';
    skeleton.className = 'product-grid-skeleton';
    skeleton.setAttribute('aria-hidden', 'true');
    const ul = document.createElement('ul');
    const gridClassTokens = grid.className.split(/\s+/).filter(Boolean).filter((c) => c !== 'product-grid');
    ul.className = ['product-grid-skeleton__grid', ...gridClassTokens].join(' ');
    ul.setAttribute('role', 'list');
    const cardMarkup =
      '<div class="product-grid-card-skeleton">' +
      '<div class="product-grid-card-skeleton__media"></div>' +
      '<div class="product-grid-card-skeleton__lines">' +
      '<div class="product-grid-card-skeleton__line product-grid-card-skeleton__line--title"></div>' +
      '<div class="product-grid-card-skeleton__line product-grid-card-skeleton__line--price"></div>' +
      '</div></div>';
    for (let i = 0; i < itemCount; i++) {
      const li = document.createElement('li');
      li.className = 'grid__item';
      li.innerHTML = cardMarkup;
      ul.appendChild(li);
    }
    skeleton.appendChild(ul);
    collection.insertBefore(skeleton, collection.firstChild);
  }

  static renderPageFromUrl(targetUrl, event, skipPushState = false) {
    const sectionId = document.getElementById('product-grid')?.dataset?.id;
    if (!sectionId) {
      window.location.href = targetUrl;
      return;
    }
    const parsed = new URL(targetUrl, window.location.origin);
    FacetFiltersForm.pendingCollectionPathname = parsed.pathname;
    const existingParams = parsed.search ? parsed.search.slice(1) : '';
    const sectionParam = `section_id=${sectionId}`;
    const fetchParams = existingParams ? `${sectionParam}&${existingParams}` : sectionParam;
    const fetchUrl = `${parsed.pathname}?${fetchParams}`;
    FacetFiltersForm.searchParamsPrev = existingParams;
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      gridContainer.querySelector('.collection')?.classList.add('loading');
      FacetFiltersForm.ensureProductGridSkeleton();
    }
    FacetFiltersForm.setMobileApplyBusy(true);
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');
    const historyUrlOptions = { targetUrl, searchParamsState: existingParams, skipPushState };
    if (!skipPushState) {
      FacetFiltersForm.urlBeforeOptimisticNavigation =
        window.location.pathname + window.location.search + window.location.hash;
      FacetFiltersForm.applyBrowserUrlAfterSectionRender(historyUrlOptions);
    } else {
      FacetFiltersForm.urlBeforeOptimisticNavigation = null;
    }
    const filterDataUrl = (el) => el.url === fetchUrl;
    const historyOptionsAfterRender = skipPushState ? historyUrlOptions : null;
    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, null, historyOptionsAfterRender)
      : FacetFiltersForm.renderSectionFromFetch(fetchUrl, event, null, historyOptionsAfterRender);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.querySelector('.collection').classList.add('loading');
    FacetFiltersForm.ensureProductGridSkeleton();
    FacetFiltersForm.setMobileApplyBusy(true);
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    const collectionPathname =
      FacetFiltersForm.pendingCollectionPathname || window.location.pathname;
    if (updateURLHash) {
      FacetFiltersForm.urlBeforeOptimisticNavigation =
        window.location.pathname + window.location.search + window.location.hash;
      FacetFiltersForm.updateURLHash(searchParams);
    } else {
      FacetFiltersForm.urlBeforeOptimisticNavigation = null;
      FacetFiltersForm.locationPrev = window.location.pathname + window.location.search;
    }

    sections.forEach((section) => {
      const url = `${collectionPathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, null, null) :
        FacetFiltersForm.renderSectionFromFetch(url, event, null, null);
    });
  }

  static applyBrowserUrlAfterSectionRender({ targetUrl, skipPushState, searchParamsState }) {
    const parsed = new URL(targetUrl, window.location.origin);
    const pathAndSearch = parsed.pathname + (parsed.search || '');
    if (!skipPushState) {
      history.pushState({ searchParams: searchParamsState ?? '' }, '', targetUrl);
    }
    FacetFiltersForm.locationPrev = pathAndSearch;
    FacetFiltersForm.pendingCollectionPathname = null;
    FacetFiltersForm.pendingSectionPathname = null;
  }

  static clearOptimisticRollbackUrlAfterSuccess() {
    FacetFiltersForm.urlBeforeOptimisticNavigation = null;
  }

  static rollbackOptimisticUrlIfFailed() {
    const saved = FacetFiltersForm.urlBeforeOptimisticNavigation;
    if (saved == null) return;
    try {
      history.replaceState(null, '', saved);
    } catch {
      /* ignore */
    }
    try {
      const parsed = new URL(saved, window.location.origin);
      FacetFiltersForm.searchParamsPrev = parsed.search ? parsed.search.slice(1) : '';
      FacetFiltersForm.locationPrev = parsed.pathname + parsed.search + parsed.hash;
    } catch {
      FacetFiltersForm.locationPrev = window.location.pathname + window.location.search;
    }
    FacetFiltersForm.urlBeforeOptimisticNavigation = null;
  }

  static renderSectionFromFetch(url, event, urlParamsToUpdate = null, historyUrlOptions = null) {
    FacetFiltersForm._latestSectionFetchId = (FacetFiltersForm._latestSectionFetchId || 0) + 1;
    const requestId = FacetFiltersForm._latestSectionFetchId;

    if (FacetFiltersForm._sectionFetchAbortController) {
      FacetFiltersForm._sectionFetchAbortController.abort();
    }
    const sectionFetchController = new AbortController();
    FacetFiltersForm._sectionFetchAbortController = sectionFetchController;

    fetch(url, { signal: sectionFetchController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then((responseText) => {
        if (requestId !== FacetFiltersForm._latestSectionFetchId) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.pendingSectionPathname = new URL(url, window.location.origin).pathname;
        try {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          if (urlParamsToUpdate !== null) FacetFiltersForm.updateURLHash(urlParamsToUpdate);
          else if (historyUrlOptions) FacetFiltersForm.applyBrowserUrlAfterSectionRender(historyUrlOptions);
          FacetFiltersForm.clearOptimisticRollbackUrlAfterSuccess();
        } finally {
          FacetFiltersForm.setMobileApplyBusy(false);
        }
      })
      .catch((err) => {
        if (err?.name === 'AbortError') return;
        if (requestId !== FacetFiltersForm._latestSectionFetchId) return;
        FacetFiltersForm.rollbackOptimisticUrlIfFailed();
        FacetFiltersForm.pendingCollectionPathname = null;
        FacetFiltersForm.pendingSectionPathname = null;
        document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.remove('loading');
        document.getElementById('ProductCount')?.classList.remove('loading');
        document.getElementById('ProductCountDesktop')?.classList.remove('loading');
        FacetFiltersForm.setMobileApplyBusy(false);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, urlParamsToUpdate = null, historyUrlOptions = null) {
    const entry = FacetFiltersForm.filterData.find(filterDataUrl);
    const html = entry.html;
    FacetFiltersForm.pendingSectionPathname = new URL(entry.url, window.location.origin).pathname;
    try {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      if (urlParamsToUpdate !== null) FacetFiltersForm.updateURLHash(urlParamsToUpdate);
      else if (historyUrlOptions) FacetFiltersForm.applyBrowserUrlAfterSectionRender(historyUrlOptions);
      FacetFiltersForm.clearOptimisticRollbackUrlAfterSuccess();
    } finally {
      FacetFiltersForm.setMobileApplyBusy(false);
    }
  }

  static renderProductGridContainer(html) {
    document.dispatchEvent(new CustomEvent('as:grid-render', {
      detail: {
         message: 'Grid has been rendered'
      }
     }))

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = parsed.getElementById('ProductGridContainer');
    if (!nextGrid) {
      FacetFiltersForm.setMobileApplyBusy(false);
      alert("Oops! Your filter criteria are too extensive. \nPlease refine your selection for better results.");
      const baseUrl = window.location.origin + window.location.pathname;
      window.location.href = baseUrl;
      return;
    };

    document.getElementById('ProductGridContainer').innerHTML = nextGrid.innerHTML;

    // make entire card clickable after re-rendering
    const productCards = document.querySelectorAll(".product-card-wrapper");

    productCards.forEach((card) => {
      const colorSwatch = card.querySelector('.color-swatch')
      const variantBadge = colorSwatch.dataset.variantBadges;
      const variantBadgePosition = colorSwatch.dataset.badgePosition;
      FacetFiltersForm.plpDisplayVariantBadges(variantBadge, variantBadgePosition, card);
    });
  }

  static plpDisplayVariantBadges = (variantBadge, variantBadgePosition, productCard) => {
    // Remove existing js added badges
    const existingJsBadges = productCard.querySelectorAll('.js-card__badge');
    if (existingJsBadges) {
      existingJsBadges.forEach((badge) => {
        badge.remove();
      });
    };
    //Add new badges
    if (!variantBadge) return;
    const variantBadgeArray = variantBadge.split(',');
    const badgeContainer = productCard.querySelector('.card__badge--container');
    const badgeAcount = badgeContainer.querySelectorAll('.card__badge--container .card__badge').length;
    if (badgeAcount >=  2) return;
    for (let i = badgeAcount; i < 2; i++) {
      if (variantBadgeArray[i]) {
        const badge = `
          <div class="card__badge js-card__badge ${variantBadgePosition}">
            <span class="badge badge--bottom-left color-background-2">${variantBadgeArray[i]}</span>
          </div>`;
        badgeContainer.insertAdjacentHTML('beforeend', badge);
      };
    };
  };

  static renderProductCount(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const pc = doc.getElementById('ProductCount');
    const pcd = doc.getElementById('ProductCountDesktop');
    const mobileCount = doc.querySelector('.mobile-facets__count-text');

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container && pc) {
      container.innerHTML = pc.innerHTML;
      container.classList.remove('loading');
    }
    if (containerDesktop && pcd) {
      containerDesktop.innerHTML = pcd.innerHTML;
      containerDesktop.classList.remove('loading');
    }
    if (mobileCount) {
      document.querySelectorAll('.mobile-facets__count-text').forEach((el) => {
        el.innerHTML = mobileCount.innerHTML;
      });
    }
  }

  static renderFilters(html, event) {
    FacetFiltersForm._toggleFacetReplaceGen = (FacetFiltersForm._toggleFacetReplaceGen || 0) + 1;
    const replaceGen = FacetFiltersForm._toggleFacetReplaceGen;
    const applyParamsSnapshot =
      FacetFiltersForm.searchParamsPrev ?? window.location.search.slice(1);

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetFilterRoot =
      '#FacetFiltersForm [data-facet-filter], #FacetFiltersFormMobile [data-facet-filter], #FacetFiltersAvailabilityForm [data-facet-filter], #FacetFiltersStockForm [data-facet-filter]';
    const facetDetailsElements = parsedHTML.querySelectorAll(facetFilterRoot);
    const toggleFilterIndexes = ['instock', 'new'];
    const matchesIndex = (element) => {
      const facetFilterEl = event ? event.target.closest('[data-facet-filter]') : undefined;
      return facetFilterEl ? element.dataset.index === facetFilterEl.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => {
      if (toggleFilterIndexes.includes(element.dataset.index)) return true;
      return !matchesIndex(element);
    });
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    const clickedIsToggle = toggleFilterIndexes.includes(
      event?.target?.closest('[data-facet-filter]')?.dataset?.index
    );

    const doReplacements = () => {
      facetsToRender.forEach((element) => {
        const isToggleFilter = toggleFilterIndexes.includes(element.dataset.index);
        if (isToggleFilter) {
          const targetFilters = document.querySelectorAll(
            `[data-facet-filter][data-index="${element.dataset.index}"]`
          );
          targetFilters.forEach((targetFilter) => {
            const formId = targetFilter.closest('form')?.id;
            const sourceBlock =
              formId &&
              parsedHTML.querySelector(
                `#${formId} [data-facet-filter][data-index="${element.dataset.index}"]`
              );
            const sourceInput = sourceBlock?.querySelector('.filter-toggle');
            const targetInput = targetFilter.querySelector('.filter-toggle');
            if (sourceInput && targetInput) {
              targetInput.checked = sourceInput.checked;
              targetInput.disabled = sourceInput.disabled;
              targetInput.dataset.toggleUrl = sourceInput.dataset.toggleUrl || '';
            }
          });
        } else {
          const sourceFormId = element.closest('form')?.id;
          const targetForm = sourceFormId ? document.getElementById(sourceFormId) : null;
          const targetFilter =
            targetForm &&
            targetForm.querySelector(
              `[data-facet-filter][data-index="${element.dataset.index}"]`
            );
          if (!targetFilter) return;
          const wasShowMoreExpanded = targetFilter.querySelector('.show-more-item:not(.hidden)');
          targetFilter.innerHTML = element.innerHTML;
          if (wasShowMoreExpanded) {
            targetFilter.querySelectorAll('.show-more-item').forEach((item) => item.classList.remove('hidden'));
            targetFilter.querySelectorAll('show-more-button .label-text').forEach((el) => el.classList.toggle('hidden', el.classList.contains('label-show-more')));
          }
        }
      });

      FacetFiltersForm.applyUrlParamsToToggleFilters(applyParamsSnapshot);
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      ['[data-facet-tag="sustainability"]', '[data-facet-tag="contract-viable"]'].forEach((sel) => {
        const sources = parsedHTML.querySelectorAll(sel);
        const targets = document.querySelectorAll(sel);
        const n = Math.min(sources.length, targets.length);
        for (let i = 0; i < n; i++) {
          const sourceInput = sources[i].querySelector('.filter-toggle');
          const targetInput = targets[i].querySelector('.filter-toggle');
          if (sourceInput && targetInput) {
            targetInput.checked = sourceInput.checked;
            targetInput.dataset.currentTags = sourceInput.dataset.currentTags || '';
          }
        }
      });

      ['#FacetFiltersFormMobile', '#FacetFiltersAvailabilityForm'].forEach((formSel) => {
        const scope = `${formSel} [data-facet-availability]`;
        parsedHTML.querySelectorAll(`${scope} input.availability-checkbox`).forEach((sourceInput) => {
          const targetInput = document.querySelector(`${scope} input[name="${sourceInput.name}"]`);
          if (targetInput) {
            targetInput.checked = sourceInput.checked;
            targetInput.disabled = sourceInput.disabled;
            const targetLabel = targetInput.closest('label.mobile-facets__label');
            if (targetLabel) {
              targetLabel.classList.toggle('mobile-facets__label--disabled', targetInput.disabled);
            }
          }
        });
      });

      const countTarget = event?.target?.closest('[data-facet-filter]');
      if (countsToRender && countTarget) FacetFiltersForm.renderCounts(countsToRender, countTarget);

      setupPriceRangeFilter();
      setupDimensionRangeFilters();
      resetSessionStorageDimensionValues();
      applySessionStorageDimensionValues();
      syncAllFacetSortSelectWidths();
    };

    if (clickedIsToggle) {
      requestAnimationFrame(() => {
        if (replaceGen !== FacetFiltersForm._toggleFacetReplaceGen) return;
        doReplacements();
      });
    } else {
      doReplacements();
    }
  }

  static applyUrlParamsToToggleFilters(searchParamsString) {
    const params = new URLSearchParams(searchParamsString);
    const pathname = FacetFiltersForm.pendingCollectionPathname || window.location.pathname;
    const pairs = [
      { index: 'new', param: 'filter.v.m.custom.new' },
      { index: 'instock', param: 'filter.v.m.custom.ready_to_ship' },
    ];
    pairs.forEach(({ index, param }) => {
      const expected = params.get(param);
      document.querySelectorAll(`[data-facet-filter][data-index="${index}"] .filter-toggle`).forEach((input) => {
        if (input.name !== param) return;
        if (expected == null) {
          input.checked = false;
          return;
        }
        if (input.value !== expected && String(expected) !== input.value) return;
        input.checked = true;
        input.disabled = false;
        const u = new URL(pathname, window.location.origin);
        if (searchParamsString) {
          u.search = `?${searchParamsString}`;
        }
        if (window.location.hash) {
          u.hash = window.location.hash;
        }
        u.searchParams.delete(param);
        const pathAndSearch = u.pathname + (u.search || '') + u.hash;
        input.dataset.toggleUrl = pathAndSearch;
      });
    });
  }

  static getFacetUrlKey(href) {
    if (!href) return '';
    try {
      const u = new URL(href, window.location.origin);
      const entries = [...u.searchParams.entries()].sort((a, b) => {
        const keyCmp = a[0].localeCompare(b[0]);
        if (keyCmp !== 0) return keyCmp;
        return String(a[1]).localeCompare(String(b[1]));
      });
      const qs = new URLSearchParams(entries).toString();
      return `${u.pathname}${qs ? `?${qs}` : ''}`;
    } catch {
      return href;
    }
  }

  static dedupeFacetRemoveByTargetUrl(container) {
    const seen = new Set();
    container.querySelectorAll('facet-remove').forEach((fr) => {
      if (
        fr.classList.contains('facet-remove__range-depth') ||
        fr.classList.contains('facet-remove__range-height') ||
        fr.classList.contains('facet-remove__range-width')
      ) {
        return;
      }
      const a = fr.querySelector('a[href]');
      if (!a) return;
      const href = (a.getAttribute('href') || '').trim();
      if (!href) return;
      const key = FacetFiltersForm.getFacetUrlKey(href);
      if (!key) return;
      if (seen.has(key)) {
        fr.remove();
      } else {
        seen.add(key);
      }
    });
  }

  static getSearchParamsStringForSupplement() {
    const prev = FacetFiltersForm.searchParamsPrev;
    const locQs = window.location.search.slice(1);
    const base = prev != null && prev !== '' ? prev : locQs;
    const merged = new URLSearchParams(base);
    const locParams = new URLSearchParams(locQs);
    ['filter.v.m.custom.new', 'filter.v.m.custom.ready_to_ship'].forEach((k) => {
      if (locParams.has(k)) merged.set(k, locParams.get(k));
    });
    return merged.toString();
  }

  static getActiveFacetPillIconBundleFromSampleInner(sampleInner) {
    const iconAndHidden = sampleInner
      ? `${sampleInner.querySelector('svg')?.outerHTML || ''}${sampleInner.querySelector('.visually-hidden')?.outerHTML || ''}`
      : '';
    const visuallyHiddenText =
      document.querySelector('.active-facets-desktop .visually-hidden, .active-facets-mobile .visually-hidden')
        ?.textContent || '';
    return { iconAndHidden, visuallyHiddenText };
  }

  static getActiveFacetPillIconBundleFromContainer(container) {
    const sampleInner = container.querySelector('facet-remove a .active-facets__button-inner');
    return FacetFiltersForm.getActiveFacetPillIconBundleFromSampleInner(sampleInner);
  }

  static getActiveFacetPillIconBundleGlobal() {
    const sampleInner = document.querySelector(
      '.active-facets-mobile facet-remove a .active-facets__button-inner'
    );
    return FacetFiltersForm.getActiveFacetPillIconBundleFromSampleInner(sampleInner);
  }

  static buildActiveFacetRemovePillMarkup({
    removeHref,
    buttonInnerBodyHtml,
    iconBundle,
    escapeAccessibilityText,
    roleButton,
    facetRemoveClass,
  }) {
    const { iconAndHidden, visuallyHiddenText } = iconBundle;
    const hiddenTail =
      iconAndHidden ||
      `<span class="visually-hidden">${
        escapeAccessibilityText ? escapeHtmlText(visuallyHiddenText) : visuallyHiddenText
      }</span>`;
    const safeHref = removeHref.replace(/"/g, '&quot;');
    const facetRemoveOpen = facetRemoveClass
      ? `<facet-remove class="${String(facetRemoveClass).replace(/"/g, '&quot;')}">`
      : '<facet-remove>';
    const roleAttr = roleButton ? ' role="button"' : '';
    return `${facetRemoveOpen}
        <a href="${safeHref}" class="active-facets__button active-facets__button--light"${roleAttr}>
          <span class="active-facets__button-inner button">${buttonInnerBodyHtml}
            ${hiddenTail}
          </span>
        </a>
      </facet-remove>`;
  }

  static insertActiveFacetPillIntoContainer(container, pillMarkup) {
    const anchor = container.querySelector('.active-facets-vertical-filter');
    if (anchor) {
      anchor.insertAdjacentHTML('afterend', pillMarkup);
    } else {
      container.insertAdjacentHTML('beforeend', pillMarkup);
    }
  }

  static supplementActiveFacetsFromUrlParams(searchParamsString) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    const params = new URLSearchParams(searchParamsString);
    const pathname =
      FacetFiltersForm.pendingSectionPathname || window.location.pathname;
    const specs = [
      { param: 'filter.v.m.custom.new', index: 'new' },
      { param: 'filter.v.m.custom.ready_to_ship', index: 'instock' },
    ];
    specs.forEach(({ param, index }) => {
      if (params.get(param) == null) return;
      const spAfterRemove = new URLSearchParams(searchParamsString);
      spAfterRemove.delete(param);
      const entries = [...spAfterRemove.entries()].sort((a, b) => {
        const keyCmp = a[0].localeCompare(b[0]);
        if (keyCmp !== 0) return keyCmp;
        return String(a[1]).localeCompare(String(b[1]));
      });
      const qs = new URLSearchParams(entries).toString();
      const removeHref = `${pathname}${qs ? `?${qs}` : ''}`;
      const expectedKey = FacetFiltersForm.getFacetUrlKey(removeHref);
      const label =
        document.querySelector(`[data-facet-filter][data-index="${index}"] .facet-filters__toggle-text`)
          ?.textContent?.trim() ||
        '';
      if (!label) return;
      const iconBundle = FacetFiltersForm.getActiveFacetPillIconBundleGlobal();
      const pillMarkup = FacetFiltersForm.buildActiveFacetRemovePillMarkup({
        removeHref,
        buttonInnerBodyHtml: label,
        iconBundle,
        escapeAccessibilityText: false,
        roleButton: false,
        facetRemoveClass: null,
      });
      const linkSelectors =
        'facet-remove a[href], a.active-facets__button[href], a.active-facets__button-remove[href]';
      ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
        const container = document.querySelector(sel);
        if (!container) return;
        const hasRemove = [...container.querySelectorAll(linkSelectors)].some(
          (a) => FacetFiltersForm.getFacetUrlKey(a.getAttribute('href')) === expectedKey
        );
        if (hasRemove) return;
        FacetFiltersForm.insertActiveFacetPillIntoContainer(container, pillMarkup);
      });
    });
    ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (container) FacetFiltersForm.dedupeFacetRemoveByTargetUrl(container);
    });
  }

  static supplementRangeDimensionFacetsFromUrl() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    const pathname = window.location.pathname;
    const sp = new URLSearchParams(window.location.search);
    const defaults = {
      depth: 'Overall depth (in inches)',
      height: 'Overall height (in inches)',
      width: 'Overall width (in inches)',
    };
    const root = document.querySelector('.facets-container');
    const labelFor = (suffix) => {
      if (!root) return defaults[suffix];
      const fromData =
        suffix === 'depth'
          ? root.dataset.rangeDimLabelDepth
          : suffix === 'height'
            ? root.dataset.rangeDimLabelHeight
            : root.dataset.rangeDimLabelWidth;
      return fromData || defaults[suffix];
    };

    const buildRemoveHref = (paramName) => {
      const next = new URLSearchParams(window.location.search);
      while (next.has(paramName)) {
        next.delete(paramName);
      }
      const qs = next.toString();
      return `${pathname}${qs ? `?${qs}` : ''}`;
    };

    const specs = [
      { param: 'filter.v.m.custom.overall_depth_in_inches_', suffix: 'depth' },
      { param: 'filter.v.m.custom.overall_height_in_inches_', suffix: 'height' },
      { param: 'filter.v.m.custom.overall_width_in_inches_', suffix: 'width' },
    ];

    specs.forEach(({ param, suffix }) => {
      const values = sp.getAll(param);
      if (values.length === 0) return;

      const nums = values.map((v) => parseFloat(v)).filter((n) => Number.isFinite(n));
      if (nums.length === 0) return;

      const removeHref = buildRemoveHref(param);
      const expectedKey = FacetFiltersForm.getFacetUrlKey(removeHref);
      const lo = Math.min(...nums);
      const hi = Math.max(...nums);
      const display = `${lo.toFixed(2)} - ${hi.toFixed(2)}`;
      const cls = `facet-remove__range-${suffix}`;
      const label = labelFor(suffix);

      const iconBundle = FacetFiltersForm.getActiveFacetPillIconBundleGlobal();

      const linkSelectors = 'facet-remove a[href], a.active-facets__button[href]';

      ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
        const container = document.querySelector(sel);
        if (!container) return;
        if (container.querySelector(`.${cls}`)) return;
        const hasRemove = [...container.querySelectorAll(linkSelectors)].some(
          (a) => FacetFiltersForm.getFacetUrlKey(a.getAttribute('href')) === expectedKey
        );
        if (hasRemove) return;

        const pillMarkup = FacetFiltersForm.buildActiveFacetRemovePillMarkup({
          removeHref,
          buttonInnerBodyHtml: `${label}:
            <span class="facet-remove__values-${suffix}">${display}</span>`,
          iconBundle,
          escapeAccessibilityText: false,
          roleButton: false,
          facetRemoveClass: cls,
        });

        FacetFiltersForm.insertActiveFacetPillIntoContainer(container, pillMarkup);
      });
    });
  }

  static supplementMaterialFacetPillsIfMissing() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    const sp = new URLSearchParams(window.location.search);
    const materialValues = sp.getAll(MATERIAL_FILTER_PARAM);
    if (materialValues.length <= 1) return;

    ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (!container) return;

      const materialPillSample = container.querySelector(
        `facet-remove a[href*="${MATERIAL_FILTER_PARAM}"] .active-facets__button-inner`
      );
      let materialLabelPrefix = 'Material';
      if (materialPillSample) {
        const txt = materialPillSample.textContent.trim();
        const idx = txt.indexOf(':');
        if (idx > 0) materialLabelPrefix = txt.slice(0, idx).trim();
      }

      const iconBundle = FacetFiltersForm.getActiveFacetPillIconBundleFromContainer(container);

      const existingKeys = new Set(
        [...container.querySelectorAll('facet-remove a[href]')].map((a) =>
          FacetFiltersForm.getFacetUrlKey(a.getAttribute('href') || '')
        )
      );

      const pathname = window.location.pathname;
      const search = window.location.search;

      materialValues.forEach((value) => {
        const qs = removeOneFilterParamValueFromSearch(search, MATERIAL_FILTER_PARAM, value);
        const removeHref = `${pathname}${qs ? `?${qs}` : ''}`;
        const removeKey = FacetFiltersForm.getFacetUrlKey(removeHref);
        if (existingKeys.has(removeKey)) return;
        const decodedLabel = value.replace(/\+/g, ' ');
        const pillMarkup = FacetFiltersForm.buildActiveFacetRemovePillMarkup({
          removeHref,
          buttonInnerBodyHtml: `${escapeHtmlText(materialLabelPrefix)}: ${escapeHtmlText(decodedLabel)}`,
          iconBundle,
          escapeAccessibilityText: true,
          roleButton: true,
          facetRemoveClass: null,
        });
        FacetFiltersForm.insertActiveFacetPillIntoContainer(container, pillMarkup);
        existingKeys.add(removeKey);
      });
    });
  }

  static getTagFacetPillContext() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return null;
    const pathname = window.location.pathname;
    const m = pathname.match(/^\/collections\/([^/]+)(?:\/(.+))?$/);
    if (!m) return null;
    const tagSegment = m[2] || '';
    const tagHandlesInPath = tagSegment.split('+').filter(Boolean);
    if (tagHandlesInPath.length === 0) return null;

    const form = document.getElementById('FacetFiltersFormMobile');
    const toggles = form
      ? form.querySelectorAll('[data-facet-tag] .filter-toggle[data-tag]')
      : document.querySelectorAll('[data-facet-tag] .filter-toggle[data-tag]');
    if (!toggles.length) return null;

    const search = window.location.search;
    const buildRemoveHref = (tagHandleToRemove) => {
      const nextSeg = removeOneTagFromPathSegment(tagSegment, tagHandleToRemove);
      const base = `/collections/${m[1]}`;
      const path = !nextSeg ? base : `${base}/${nextSeg}`;
      return `${path}${search}`;
    };

    return { tagHandlesInPath, toggles, buildRemoveHref };
  }

  static supplementTagFacetPillsIfMissing(ctx) {
    const resolved = ctx === undefined ? FacetFiltersForm.getTagFacetPillContext() : ctx;
    if (!resolved) return;
    const { tagHandlesInPath, toggles, buildRemoveHref } = resolved;

    ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (!container) return;

      const iconBundle = FacetFiltersForm.getActiveFacetPillIconBundleFromContainer(container);

      const existingKeys = new Set(
        [...container.querySelectorAll('facet-remove a[href]')].map((a) =>
          FacetFiltersForm.getFacetUrlKey(a.getAttribute('href') || '')
        )
      );

      toggles.forEach((input) => {
        const tagHandle = input.dataset.tag;
        if (!tagHandle || !tagHandlesInPath.includes(tagHandle)) return;

        const label =
          input.closest('[data-facet-tag]')?.querySelector('.facet-filters__toggle-text')?.textContent?.trim() ||
          tagHandle;
        if (
          [...container.querySelectorAll('facet-remove')].some(
            (fr) => FacetFiltersForm.getFacetRemovePillLabelText(fr) === label
          )
        ) {
          return;
        }

        const removeHref = buildRemoveHref(tagHandle);
        const expectedKey = FacetFiltersForm.getFacetUrlKey(removeHref);
        if (existingKeys.has(expectedKey)) return;

        const pillMarkup = FacetFiltersForm.buildActiveFacetRemovePillMarkup({
          removeHref,
          buttonInnerBodyHtml: escapeHtmlText(label),
          iconBundle,
          escapeAccessibilityText: true,
          roleButton: true,
          facetRemoveClass: null,
        });
        FacetFiltersForm.insertActiveFacetPillIntoContainer(container, pillMarkup);
        existingKeys.add(expectedKey);
      });
    });
  }

  static getFacetRemovePillLabelText(fr) {
    const span = fr.querySelector('.active-facets__button-inner');
    if (!span) return '';
    const clone = span.cloneNode(true);
    clone.querySelectorAll('svg, .visually-hidden').forEach((el) => el.remove());
    return clone.textContent.trim();
  }

  static dedupeTagFacetPills(ctx) {
    const resolved = ctx === undefined ? FacetFiltersForm.getTagFacetPillContext() : ctx;
    if (!resolved) return;
    const { tagHandlesInPath, toggles, buildRemoveHref } = resolved;

    ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (!container) return;

      toggles.forEach((input) => {
        const tagHandle = input.dataset.tag;
        if (!tagHandle || !tagHandlesInPath.includes(tagHandle)) return;

        const toggleLabel =
          input.closest('[data-facet-tag]')?.querySelector('.facet-filters__toggle-text')?.textContent?.trim() ||
          tagHandle;
        const canonicalHref = buildRemoveHref(tagHandle);
        const canonicalKey = FacetFiltersForm.getFacetUrlKey(canonicalHref);

        const matches = [...container.querySelectorAll('facet-remove')].filter(
          (fr) => FacetFiltersForm.getFacetRemovePillLabelText(fr) === toggleLabel
        );
        if (matches.length === 0) return;

        const canonicalMatch = matches.find((fr) => {
          const a = fr.querySelector('a[href]');
          return a && FacetFiltersForm.getFacetUrlKey(a.getAttribute('href') || '') === canonicalKey;
        });
        if (canonicalMatch) {
          matches.forEach((fr) => {
            if (fr !== canonicalMatch) fr.remove();
          });
          return;
        }
        const [first, ...rest] = matches;
        const firstA = first.querySelector('a[href]');
        if (firstA) firstA.setAttribute('href', canonicalHref);
        rest.forEach((fr) => fr.remove());
      });
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.supplementActiveFacetsFromUrlParams(FacetFiltersForm.getSearchParamsStringForSupplement());
    FacetFiltersForm.supplementRangeDimensionFacetsFromUrl();
    FacetFiltersForm.supplementMaterialFacetPillsIfMissing();
    const tagFacetCtx = FacetFiltersForm.getTagFacetPillContext();
    FacetFiltersForm.supplementTagFacetPillsIfMissing(tagFacetCtx);
    FacetFiltersForm.dedupeTagFacetPills(tagFacetCtx);
    ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (container) FacetFiltersForm.dedupeFacetRemoveByTargetUrl(container);
    });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '#FacetFiltersForm .facet-filters.sorting:not(.has-toggle)',
      '#FacetSortToolbarForm .facet-filters.sorting',
      '#FacetSortForm .facet-filters.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      if (!sourceEl) return;
      const targetEl = document.querySelector(selector);
      if (!targetEl) return;
      targetEl.innerHTML = sourceEl.innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    if (!target) return;
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const path = FacetFiltersForm.pendingCollectionPathname || window.location.pathname;
    history.pushState({ searchParams }, '', `${path}${searchParams && '?'.concat(searchParams)}`);
    FacetFiltersForm.pendingCollectionPathname = null;
    FacetFiltersForm.pendingSectionPathname = null;
    FacetFiltersForm.locationPrev = window.location.pathname + window.location.search;
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form, excludeSort = false) {
    const formData = new FormData(form);
    if (excludeSort) {
      formData.delete('sort_by');
    }
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'filter.v.m.custom.ready_to_ship') {
        params.set(key, value);
      } else {
        params.append(key, value);
      }
    });
    return params.toString();
  }

  serializeFormForMerge(f, sortFormId) {
    const sortCarrierIds = [
      'FacetSortForm',
      'FacetSortToolbarForm',
      'FacetFiltersForm',
      'FacetFiltersFormMobile',
    ];
    if (sortCarrierIds.includes(f.id) && sortFormId && f.id !== sortFormId) {
      return this.createSearchParams(f, true);
    }
    return this.createSearchParams(f);
  }

  static getMergedSearchParamsForMobileApply(instance, event) {
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return '';
    const sortFormId = FacetFiltersForm.resolveSortFormId(form, event);
    const merged = new URLSearchParams(window.location.search);
    const namesInForm = new Set(
      Array.from(form.querySelectorAll('[name]')).map((el) => el.name)
    );
    namesInForm.forEach((name) => {
      if (name === MATERIAL_FILTER_PARAM) return;
      merged.delete(name);
    });
    if (namesInForm.has(MATERIAL_FILTER_PARAM)) {
      mergeMaterialParamsFromUrlAndForm(merged, form);
    }
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      if (key === MATERIAL_FILTER_PARAM) return;
      if (key === 'filter.v.m.custom.ready_to_ship') {
        merged.set(key, value);
      } else {
        merged.append(key, value);
      }
    });
    if (!merged.has('sort_by') && sortFormId) {
      const sortFormEl = document.getElementById(sortFormId);
      if (sortFormEl) {
        const sortParams = new URLSearchParams(instance.serializeFormForMerge(sortFormEl, sortFormId));
        const sortBy = sortParams.get('sort_by');
        if (sortBy) merged.set('sort_by', sortBy);
      }
    }
    return merged.toString();
  }

  static resolveSortFormId(triggerForm, event) {
    if (triggerForm?.id === 'FacetSortForm' || triggerForm?.id === 'FacetSortToolbarForm') {
      return triggerForm.id;
    }
    if (triggerForm?.id === 'FacetFiltersForm' && event?.target?.name === 'sort_by') {
      return 'FacetFiltersForm';
    }
    if (triggerForm?.id === 'FacetFiltersFormMobile' && event?.target?.name === 'sort_by') {
      return 'FacetFiltersFormMobile';
    }
    const toolbar = document.getElementById('FacetSortToolbarForm');
    const vertical = document.getElementById('FacetSortForm');
    const mobile = document.getElementById('FacetFiltersFormMobile');
    if (vertical && toolbar) return 'FacetSortForm';
    if (toolbar && mobile && !document.getElementById('FacetFiltersForm')) {
      return 'FacetSortToolbarForm';
    }
    if (toolbar) return 'FacetSortToolbarForm';
    if (vertical) return 'FacetSortForm';
    if (mobile) return 'FacetFiltersFormMobile';
    return null;
  }

  createSearchParamsPreservingUrlParams(form) {
    const merged = new URLSearchParams(window.location.search);
    const formData = new FormData(form);
    const namesInForm = new Set(
      Array.from(form.querySelectorAll('[name]')).map((el) => el.name)
    );
    namesInForm.forEach((name) => merged.delete(name));
    formData.forEach((value, key) => {
      if (key === 'filter.v.m.custom.ready_to_ship') {
        merged.set(key, value);
      } else {
        merged.append(key, value);
      }
    });
    return merged.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target?.closest('form');
    if (!form?.id) return;
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement?.classList?.contains('mobile-facets__checkbox')) {
      const searchParams = this.createSearchParamsPreservingUrlParams(form);
      this.onSubmitForm(searchParams, event);
    } else {
      document.querySelectorAll('.no-js-list').forEach((el) => el.remove());
      const sortFormId = FacetFiltersForm.resolveSortFormId(form, event);

      if (form.id === 'FacetSortToolbarForm' || form.id === 'FacetSortForm') {
        const merged = new URLSearchParams(window.location.search);
        const sortParams = new URLSearchParams(this.serializeFormForMerge(form, sortFormId));
        sortParams.forEach((value, key) => {
          merged.set(key, value);
        });
        this.onSubmitForm(merged.toString(), event);
        return;
      }

      const forms = [];
      const isMobile = form.id === 'FacetFiltersFormMobile';

      const desktopFiltersPresent = Boolean(document.getElementById('FacetFiltersForm'));
      sortFilterForms.forEach((f) => {
        if (!isMobile) {
          if (f.id === 'FacetSortForm' || f.id === 'FacetFiltersForm' || f.id === 'FacetSortToolbarForm' || f.id === 'FacetFiltersAvailabilityForm') {
            forms.push(this.serializeFormForMerge(f, sortFormId));
          } else if (f.id === 'FacetFiltersFormMobile' && !desktopFiltersPresent) {
            forms.push(this.serializeFormForMerge(f, sortFormId));
          }
        } else if (f.id === 'FacetFiltersFormMobile') {
          const mergedParams = new URLSearchParams(this.serializeFormForMerge(f, sortFormId));
          if (!mergedParams.has('sort_by') && sortFormId) {
            const sortFormEl = document.getElementById(sortFormId);
            if (sortFormEl) {
              const sortParams = new URLSearchParams(this.serializeFormForMerge(sortFormEl, sortFormId));
              const sortBy = sortParams.get('sort_by');
              if (sortBy) mergedParams.set('sort_by', sortBy);
            }
          }
          forms.push(mergedParams.toString());
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const link = event.currentTarget;
    const linkUrl = new URL(link.href, window.location.origin);
    const currentPath = window.location.pathname;
    const linkPath = linkUrl.pathname;
    if (linkPath !== currentPath) {
      const target = new URL(link.href, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);
      const sortBy = currentParams.get('sort_by');
      if (sortBy && !target.searchParams.has('sort_by')) {
        target.searchParams.set('sort_by', sortBy);
      }
      FacetFiltersForm.renderPageFromUrl(target.toString(), event);
    } else {
      FacetFiltersForm.renderPage(linkUrl.search.slice(1), event);
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.pendingSectionPathname = null;
FacetFiltersForm.pendingCollectionPathname = null;
FacetFiltersForm.urlBeforeOptimisticNavigation = null;
FacetFiltersForm._sectionFetchAbortController = null;
FacetFiltersForm.locationPrev = window.location.pathname + window.location.search;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

(() => {
  if (!document.querySelector('facet-filters-form')) return;
  const sp = window.location.search.slice(1);
  if (sp) {
    FacetFiltersForm.applyUrlParamsToToggleFilters(sp);
    FacetFiltersForm.supplementActiveFacetsFromUrlParams(sp);
    FacetFiltersForm.supplementRangeDimensionFacetsFromUrl();
    FacetFiltersForm.supplementMaterialFacetPillsIfMissing();
  }
  const tagFacetCtx = FacetFiltersForm.getTagFacetPillContext();
  FacetFiltersForm.supplementTagFacetPillsIfMissing(tagFacetCtx);
  FacetFiltersForm.dedupeTagFacetPills(tagFacetCtx);
  ['.active-facets-desktop', '.active-facets-mobile'].forEach((sel) => {
    const container = document.querySelector(sel);
    if (container) FacetFiltersForm.dedupeFacetRemoveByTargetUrl(container);
  });
})();

(() => {
  let sortFocusFromKeyboard = false;
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') sortFocusFromKeyboard = true;
  });
  document.addEventListener('pointerdown', () => {
    sortFocusFromKeyboard = false;
  });
  document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!target.matches?.('select.facet-filters__sort')) return;
    if (sortFocusFromKeyboard) {
      target.removeAttribute('data-facet-sort-focus');
    } else {
      target.setAttribute('data-facet-sort-focus', 'pointer');
    }
    sortFocusFromKeyboard = false;
  });
  document.addEventListener('focusout', (event) => {
    const target = event.target;
    if (target.matches?.('select.facet-filters__sort')) {
      target.removeAttribute('data-facet-sort-focus');
    }
  });
})();

(() => {
  const run = () => syncAllFacetSortSelectWidths();
  document.addEventListener('change', (event) => {
    if (event.target.matches?.('select.facet-filters__sort')) syncFacetSortSelectWidth(event.target);
  });
  if (typeof domReady === 'function') {
    domReady(() => {
      run();
      if (document.fonts?.ready) document.fonts.ready.then(run);
    });
  } else {
    run();
    if (document.fonts?.ready) document.fonts.ready.then(run);
  }
  window.addEventListener('resize', debounce(run, 150));
  setTimeout(() => {
    document.querySelectorAll('#FacetSortToolbarForm').forEach((form) => {
      if (!form?.dataset?.facetSortWidth) {
        form.setAttribute('data-facet-sort-width', 'ready');
      }
    });
  }, 2500);
})();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

setupPriceRangeFilter = () => {
  const sliderLarge = document.getElementById('slider--price-range-large');

  if (sliderLarge) {
    const sliderMin = parseFloat(sliderLarge.dataset.min);
    const sliderMinCurrent = parseFloat(sliderLarge.dataset.minCurrent);
    const sliderMax = parseFloat(sliderLarge.dataset.max);
    const sliderMaxCurrent = parseFloat(sliderLarge.dataset.maxCurrent);

    noUiSlider.create(sliderLarge, {
      start: [sliderMin, sliderMax],
      connect: true,
      range: {
        'min': sliderMin,
        'max': sliderMax
      },
      step: 100
    });

    sliderLarge.noUiSlider.set([sliderMinCurrent, sliderMaxCurrent]);

    const rangeSliderValueElement = document.querySelector('.slider-range-value');

    if (rangeSliderValueElement) {
      sliderLarge.noUiSlider.on('change', (values, handle) => {
          const rangeLowValue = rangeSliderValueElement.querySelector('.low-value');
          rangeLowValue.innerHTML = `$ ${values[0]}`;
          const rangeHighValue = rangeSliderValueElement.querySelector('.high-value');
          rangeHighValue.innerHTML = `$ ${values[1]}`;
          // rangeSliderValueElement.innerHTML = values.join(' - ');

          // update the hidden fields to get the filter to work
          // Filter-Price-GTE, Filter-Price-LTE
          const facetsForm = document.getElementById('FacetFiltersForm');
          const eventPriceChange = new Event('input');
          const priceGTE = document.getElementById('Filter-Price-GTE');
          const priceLTE = document.getElementById('Filter-Price-LTE');

          if (handle === 0) {
            priceGTE.value = values[handle];
            facetsForm.dispatchEvent(eventPriceChange);
          }

          if (handle === 1) {
            priceLTE.value = values[handle];
            facetsForm.dispatchEvent(eventPriceChange);
          }
      });
    }
  }
}

domReady(setupPriceRangeFilter);

const setupDimensionRangeFilters = () => {
	dimensionRangeInputFlushCallbacks.length = 0;
	const facetRangeFilters = document.querySelectorAll('.facets-range-dimension-container');
	facetRangeFilters.forEach(rangeFilter => initRangeFilter(rangeFilter));
	resetSessionStorageDimensionValues();
	applySessionStorageDimensionValues();
};

domReady(setupDimensionRangeFilters);

const initRangeFilter = (rangeFilter) => {
	const minInput = rangeFilter.querySelector('.facets-range-dimension-input-min');
	const maxInput = rangeFilter.querySelector('.facets-range-dimension-input-max');
	if (!minInput || !maxInput) return;

	const dimensionType = minInput.dataset.dimensionType || maxInput.dataset.dimensionType;
	const minLimit = parseFloat(minInput.min);
	const maxLimit = parseFloat(minInput.max);

	const tryApplyRangeFromInputs = () => {
		const rawMin = minInput.value.trim();
		const rawMax = maxInput.value.trim();
		if (!rawMin || !rawMax) return;

		let vMin = parseFloat(rawMin);
		let vMax = parseFloat(rawMax);
		if (!Number.isFinite(vMin) || !Number.isFinite(vMax)) return;

		if (vMin < minLimit) {
			vMin = minLimit;
			minInput.value = String(minLimit);
		}
		if (vMin > maxLimit) {
			vMin = maxLimit;
			minInput.value = String(maxLimit);
		}
		if (vMax < minLimit) {
			vMax = minLimit;
			maxInput.value = String(minLimit);
		}
		if (vMax > maxLimit) {
			vMax = maxLimit;
			maxInput.value = String(maxLimit);
		}

		const minValue = Math.min(vMin, vMax);
		const maxValue = Math.max(vMin, vMax);
		applyRangeFilterValues(minValue, maxValue, dimensionType);
	};

	const debouncedApply = debounce(tryApplyRangeFromInputs, DIMENSION_RANGE_INPUT_DEBOUNCE_MS);

	dimensionRangeInputFlushCallbacks.push(tryApplyRangeFromInputs);

	[minInput, maxInput].forEach((input) => {
		input.addEventListener('input', debouncedApply);
	});
};

const applyRangeFilterValues = (minValue, maxValue, dimensionType) => {
	const dimensionLists = document.querySelectorAll('.facets-dimension-list');
  const dimensionListsArray = Array.from(dimensionLists);
	const macthedDimensionList = dimensionListsArray.find(list => list.dataset.dimensionType === dimensionType);

	if (!macthedDimensionList) return;
	
	updateDimensionCheckboxes(macthedDimensionList, minValue, maxValue);

	const dimensionInputType = dimensionType.replace('overall', '').replace('(in inches)', '').trim();
  sessionStorage.setItem(`range-dimention-min-${dimensionInputType}`, minValue);
  sessionStorage.setItem(`range-dimention-max-${dimensionInputType}`, maxValue);
};

const updateDimensionCheckboxes = (dimensionList, minInputValueNumber, maxInputValueNumber) => {
	const macthedDimensionCheckboxes = dimensionList.querySelectorAll('input[type="checkbox"]');

	let checkedDimensionCheckboxesCount = 0;
  macthedDimensionCheckboxes.forEach((checkbox) => {
		if (checkbox.disabled) return;

    const checkboxValue = parseFloat(checkbox.value);
    const shouldCheck =
      checkboxValue >= minInputValueNumber && checkboxValue <= maxInputValueNumber;
    if (checkbox.checked !== shouldCheck) {
      checkbox.checked = shouldCheck;
    }
    if (shouldCheck) checkedDimensionCheckboxesCount++;
  });

  if (checkedDimensionCheckboxesCount === 0) {
    noneOfBoxCheckedNofitication(dimensionList);
  }

  const form = dimensionList.closest('form');
  const triggerInput =
    dimensionList.querySelector('input.mobile-facets__checkbox[type="checkbox"]') ||
    dimensionList.querySelector('input[type="checkbox"]');
  if (form && triggerInput) {
    triggerInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
};

function resetSessionStorageDimensionValues () {
  const rangeDimensionRemoveDepth = document.querySelector('.facet-remove__range-depth'); 
  const rangeDimensionRemoveWidth = document.querySelector('.facet-remove__range-width');
  const rangeDimensionRemoveHeight = document.querySelector('.facet-remove__range-height');
  if (!rangeDimensionRemoveDepth) {
    sessionStorage.removeItem('range-dimention-min-depth');
    sessionStorage.removeItem('range-dimention-max-depth');
  };
  if (!rangeDimensionRemoveWidth) {
    sessionStorage.removeItem('range-dimention-min-width');
    sessionStorage.removeItem('range-dimention-max-width');
  };
  if (!rangeDimensionRemoveHeight) {
    sessionStorage.removeItem('range-dimention-min-height');
    sessionStorage.removeItem('range-dimention-max-height');
  };
};

const applySessionStorageDimensionValues = () => {
	const dimensionTypes = ['depth', 'width', 'height']
	dimensionTypes.forEach(type => applySessionValuesToDimensionElements(type))
};

const applySessionValuesToDimensionElements = (type) => {
  const rangeDimensionMin = sessionStorage.getItem(`range-dimention-min-${type}`);
  const rangeDimensionMax = sessionStorage.getItem(`range-dimention-max-${type}`);
  const rangeDimensionRemove = document.querySelectorAll(`.facet-remove__range-${type}`); 
  
  if (rangeDimensionRemove && rangeDimensionMin && rangeDimensionMax) {
    rangeDimensionRemove.forEach((removeButton) => {
      removeButton.querySelector(`.facet-remove__values-${type}`).innerHTML = `${parseFloat(rangeDimensionMin).toFixed(2)} - ${parseFloat(rangeDimensionMax).toFixed(2)}`;
    });
  };
  
  const rangeDimensionMinInput = document.querySelectorAll(`.facets-range-dimension-input-min-${type}`);
  if (rangeDimensionMinInput && rangeDimensionMin) {
    rangeDimensionMinInput.forEach((minInput) => {
      minInput.value = parseFloat(rangeDimensionMin).toFixed(2);
    });
  };

  const rangeDimensionMaxInput = document.querySelectorAll(`.facets-range-dimension-input-max-${type}`);
  if (rangeDimensionMaxInput && rangeDimensionMax) {
    rangeDimensionMaxInput.forEach((maxInput) => {
      maxInput.value = parseFloat(rangeDimensionMax).toFixed(2);
    });
  };
};


const noneOfBoxCheckedNofitication = (macthedDimensionList) =>  {
  const macthedDimensionListContainer = macthedDimensionList.parentElement;
  if (!macthedDimensionListContainer) return;

	const macthedDimensionInputContainer = macthedDimensionListContainer.parentElement;
	if (!macthedDimensionInputContainer) return;

	macthedDimensionInputContainer.querySelectorAll('.none-of-box-checked-notification').forEach((el) => el.remove());

	const noneOfBoxCheckedNofitication = document.createElement('p');
	noneOfBoxCheckedNofitication.classList.add('none-of-box-checked-notification');
	noneOfBoxCheckedNofitication.innerHTML = `No matching dimensions due to the applied filters.<br>Please try another range.`;

	macthedDimensionInputContainer.insertBefore(
		noneOfBoxCheckedNofitication,
		macthedDimensionListContainer.nextSibling
	);

	setTimeout(() => {
		noneOfBoxCheckedNofitication.style.opacity = 0;
	}, 2500);

	setTimeout(() => {
		noneOfBoxCheckedNofitication.remove();
	}, 3000);
};

const FACETS_STICKY_TOP_VAR = '--facets-sticky-top';
const FACETS_STICKY_RESIZE_DEBOUNCE_MS = 150;
const FACETS_STICKY_INITIAL_SCROLL_EPSILON = 2;

/*
  Sticky facets bar: --facets-sticky-top is consumed by .facets-wrapper in component-facets.css.

  Use 0 when: (1) scrollTop is near the top (<= epsilon), or (2) last scroll direction was down — avoids fighting the
  header hide-on-scroll-down behavior and matches “only reserve header height when scrolling up below the fold”.

  Measure when: scrolling up and not at the top — read sticky-header or #shopify-section-header
  getBoundingClientRect().bottom, floored with Math.floor.

  Scroll: updates are coalesced with requestAnimationFrame; trailing debounce on scroll would stop updating mid-gesture.

  Resize: debounced to limit layout reads.

  Header transform (#shopify-section-header.animate, ~0.15s): during the transition, rect.bottom is in-between; reading
  only after scroll ends leaves --facets-sticky-top short. On transitionstart for transform, run an rAF loop until
  transitionend/transitioncancel, then one final update so the offset matches the settled header.
*/

(function initFacetsStickyTopOffset() {
  let scrollRaf = null;
  let lastScrollTop = 0;
  let lastScrollDirection = 'down';
  let headerTransformTransitionActive = false;
  let headerTransitionFollowRaf = null;

  function getStickyHeaderAnchor() {
    return document.querySelector('sticky-header') || document.getElementById('shopify-section-header');
  }

  function stopHeaderTransformTransitionFollow() {
    if (headerTransitionFollowRaf !== null) {
      cancelAnimationFrame(headerTransitionFollowRaf);
      headerTransitionFollowRaf = null;
    }
  }

  function tickHeaderTransformTransitionFollow() {
    headerTransitionFollowRaf = null;
    if (!headerTransformTransitionActive) return;
    updateFacetsStickyTop();
    headerTransitionFollowRaf = requestAnimationFrame(tickHeaderTransformTransitionFollow);
  }

  function onHeaderTransformTransitionStart(event) {
    const headerSection = document.getElementById('shopify-section-header');
    if (!headerSection || event.target !== headerSection) return;
    if (event.propertyName !== 'transform' && event.propertyName !== '-webkit-transform') return;
    headerTransformTransitionActive = true;
    stopHeaderTransformTransitionFollow();
    headerTransitionFollowRaf = requestAnimationFrame(tickHeaderTransformTransitionFollow);
  }

  function onHeaderTransformTransitionEnd(event) {
    const headerSection = document.getElementById('shopify-section-header');
    if (!headerSection || event.target !== headerSection) return;
    if (event.propertyName !== 'transform' && event.propertyName !== '-webkit-transform') return;
    headerTransformTransitionActive = false;
    stopHeaderTransformTransitionFollow();
    updateFacetsStickyTop();
  }

  function setFacetsStickyTopPx(px) {
    document.documentElement.style.setProperty(FACETS_STICKY_TOP_VAR, `${px}px`);
  }

  function updateFacetsStickyTop() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= FACETS_STICKY_INITIAL_SCROLL_EPSILON) {
      setFacetsStickyTopPx(0);
      lastScrollDirection = 'down';
      lastScrollTop = scrollTop;
      return;
    }

    if (lastScrollDirection === 'down') {
      setFacetsStickyTopPx(0);
      return;
    }

    const anchor = getStickyHeaderAnchor();
    if (!anchor) return;
    const bottom = anchor.getBoundingClientRect().bottom;
    const topPx = Math.max(0, Math.floor(bottom));
    setFacetsStickyTopPx(topPx);
  }

  function onScroll() {
    if (scrollRaf != null) return;
    scrollRaf = requestAnimationFrame(() => {
      scrollRaf = null;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) lastScrollDirection = 'down';
      else if (scrollTop < lastScrollTop) lastScrollDirection = 'up';
      lastScrollTop = scrollTop;
      updateFacetsStickyTop();
    });
  }

  const onResizeDebounced = debounce(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    lastScrollTop = scrollTop;
    if (scrollTop <= FACETS_STICKY_INITIAL_SCROLL_EPSILON) lastScrollDirection = 'down';
    updateFacetsStickyTop();
  }, FACETS_STICKY_RESIZE_DEBOUNCE_MS);

  function bind() {
    if (!document.querySelector('.facets-wrapper')) return;
    lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    lastScrollDirection =
      lastScrollTop <= FACETS_STICKY_INITIAL_SCROLL_EPSILON ? 'down' : 'up';
    updateFacetsStickyTop();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResizeDebounced);

    const headerSection = document.getElementById('shopify-section-header');
    if (headerSection) {
      headerSection.addEventListener('transitionstart', onHeaderTransformTransitionStart);
      headerSection.addEventListener('transitionend', onHeaderTransformTransitionEnd);
      headerSection.addEventListener('transitioncancel', onHeaderTransformTransitionEnd);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();